import React, { useContext } from "react";
import { ThemeContext } from "styled-components";

import StyledIcon from "../Interfaces/StyledIcon";

const LeftArrow: React.FunctionComponent<StyledIcon> = ({
  fill = "primary-white",
}) => {
  const theme = useContext(ThemeContext);
  const hexColor = theme.colors[fill] || fill;
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.81565 0.109851L6.19693 0.72857C6.05049 0.875007 6.05049 1.11244 6.19693 1.25891L11.0447 6.10669H0.375C0.167906 6.10669 0 6.27459 0 6.48169V7.35669C0 7.56378 0.167906 7.73169 0.375 7.73169H11.0447L6.19693 12.5795C6.05049 12.7259 6.05049 12.9634 6.19693 13.1098L6.81565 13.7286C6.96209 13.875 7.19952 13.875 7.34599 13.7286L13.8902 7.18437C14.0366 7.03794 14.0366 6.8005 13.8902 6.65403L7.34596 0.109851C7.19952 -0.0366171 6.96209 -0.0366171 6.81565 0.109851Z"
        fill={hexColor}
      />
    </svg>
  );
};

export default LeftArrow;
